import React from 'react';
import Button from '../../components/atoms/Button/Button';
import Container from '../../components/atoms/Container/Container';
import styles from '../ReceiptUnconfirmedPage/ReceiptUnconfirmed.module.scss';

interface Props {
  onContactSupport: () => void;
}

/**
 * CPAYMENT-1716: клиент перешёл к загрузке чека (то есть, вероятно, уже переводил деньги), но
 * время тикета вышло раньше, чем он загрузил файл. Экран отмены здесь бесполезен — он предлагает
 * вернуться к мерчанту и ничего не говорит про уже отправленный перевод, поэтому даём прямой
 * следующий шаг: поддержка.
 *
 * Текст нейтральный и без обещаний: платёж ещё может быть зачислен разбором, но это решает
 * оператор, а не страница.
 */
const PaymentExpired: React.FC<Props> = ({ onContactSupport }) => (
  <section className={styles.wrapper}>
    <Container>
      <h3 className={styles.title}>Время на оплату истекло</h3>
      <p className={styles.text}>
        Если вы уже перевели деньги, обратитесь в поддержку — платёж проверит специалист.
      </p>
      <Button
        onClick={onContactSupport}
        variant='primary'
        dataSentryElement='support'
      >
        Обратиться в поддержку
      </Button>
    </Container>
  </section>
);

export default PaymentExpired;
